import Tooltip from 'app/common/Tooltip'
import React from 'react'
import './DeviceAvataar.scss'

type DeviceAvataarProps = {
  src: string
  title: string
  placement: 'top' | 'bottom' | 'left' | 'right'
}
const DeviceAvataar: React.FC<DeviceAvataarProps> = ({ src, title, placement }) => {
  return (
    <div className="deviceAvataar">
      {' '}
      <Tooltip title={title} placement={placement}>
        <img src={src} alt={'Phone'} width="40px" height="40px" />
      </Tooltip>
    </div>
  )
}
export default DeviceAvataar
